import { useNavigate } from "react-router-dom";

import {
  Category,
  Column1,
  ContentContainer,
  DataTitle,
  Row2,
} from "pages/home/components/Layout";

// 카테고리 + 제목 섹션 컴포넌트
export const InquiriesTitle = ({ slicedData }) => {
  const navigate = useNavigate();

  // 출처(__source)에 따라 문의(ask)/건의(suggestion) 상세로 이동한다.
  const goToDetail = (data) => {
    const path =
      data.__source === "inquiry"
        ? `/communication/ask/${data.id}`
        : `/communication/suggestion/${data.id}`;
    navigate(path);
  };

  return (
    <Column1>
      {slicedData.map((data) => (
        <Row2
          key={`inquiry_title_${data.__source}_${data.id ?? data.createdAt ?? data.title}`}
          onClick={() => goToDetail(data)}
          style={{
            cursor: data.status === 2 ? "not-allowed" : "pointer",
            // backgroundColor: 'yellow'
          }}
        >
          {data.__source === "inquiry" ? (
            <Category $color="#0079E0">문의</Category>
          ) : (
            <Category $color="#FF9B26">건의</Category>
          )}
          <ContentContainer $width={460} $height={22} $flex="flex-start">
            <DataTitle>
              {(data.title ?? "").length > 32
                ? `${data.title.slice(0, 32)}...`
                : data.title}
            </DataTitle>
          </ContentContainer>
        </Row2>
      ))}
    </Column1>
  );
};
